import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import * as z from "zod";

export const enRouteInventoryFilterNames = [
  "returnsCenterId",
  "status",
  "teamId",
] as const;

export type EnRouteInventoryFilterName =
  (typeof enRouteInventoryFilterNames)[number];

export const EnRouteInventoryFiltersInputSchema = z.object({
  advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
});

export type EnRouteInventoryFiltersInput = z.infer<
  typeof EnRouteInventoryFiltersInputSchema
>;
